import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AgodaContentService } from './store/agoda'
import { BdcContentV2Service } from './store/bdc/service-v2'

const services = [
  //
  BdcContentV2Service,
  AgodaContentService,
]

@NgModule({
  imports: [CommonModule],
  providers: [...services],
})
export class ChannelContentLibraryModule {}
